import { IGrade } from '../models/grades-model';
import { Grade } from '../models/grades-viewmodel';

/**
 * Mapper for the Recent Grades service
 */

export default class GradeMapper {
    public mapGrade(item: IGrade): Grade {
        return new Grade(
            item.moduleDescription,
            item.grade,
            item.creditsEarned,
            item.moduleCode,
            item.appraisalDate
        );
    }
}
